import navigateTo from './navigateTo';

function navigateToPaymentGateway(result) {
    const redirectUrl = result && result.redirectUrl;
    if (typeof redirectUrl === 'string') {
        navigateTo(redirectUrl);
    }
}

export default navigateToPaymentGateway;
